import React, { Component } from "react";
import BigCalendar from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import "moment/locale/de";
import "./style/calendar.css";
import SectionFooter from "./sectionfooter";
import events from "./data/calendar.json";

moment.locale("de");

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

class Calendar extends Component {
  constructor() {
    super();
    events.termine.forEach(function(element) {
      element.start = moment(element.start).toDate();
      element.end = moment(element.end).toDate();
    });
  }
  render() {
    return (
      <section id="calendar">
        <h1>Kalender</h1>
        <div className="calendar-wrapper">
          <BigCalendar
            messages={{
              allDay: "Ganztags",
              previous: "Vorherige",
              next: "Nächste",
              today: "Heute",
              month: "Monat",
              week: "Woche",
              day: "Tag",
              agenda: "Termine"
            }}
            {...this.props}
            culture="de-de"
            events={events.termine}
          />
        </div>
        <div className="primary">
          <br />
          <p className="intro">
            <u>
              <a href={require("../pdf/Termine2018.pdf")}>
                Kalender Herunterladen
              </a>
            </u>
          </p>
          <p className="intro">
            Aktive, die bei einem Auftritt nicht teilnehmen k&ouml;nnen, haben
            sich so fr&uuml;h wie m&ouml;glich beim Tambourmajor abzumelden!
          </p>
          <p className="intro">
            &Auml;nderung vorbehalten! Bei einigen Veranstaltungen und
            Umz&uuml;gen liegen noch keine Vertr&auml;ge vor, bzw. die Uhrzeiten
            sind noch nicht bekannt. Genauere Informationen zu diesen Terminen
            folgen.
          </p>
          <p className="intro">Antreten bedeutet: Abmarsch, Zugbeginn</p>
        </div>
        <SectionFooter />
      </section>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/components/calendar.js